'use client'

import Button from '@/components/form/button'
import Input from '@/components/form/input'
import { platformAction } from '@/lib/actions/contact'
import IconEmail from '@icon/variable/form/email.svg'
import IconMessage from '@icon/variable/form/message.svg'
import IconPhone from '@icon/variable/form/phone.svg'
import IconUser from '@icon/variable/form/user.svg'
import { values } from 'lodash-es'
import { useActionState, useEffect, useMemo } from 'react'
import { toast } from 'react-toastify'

const initialState = {
  error: {} as Record<string, string>,
  errorMessage: '',
  ok: false,
}

export default function Form() {
  const [state, formAction, pending] = useActionState(
    platformAction,
    initialState
  )

  const errorMessage = useMemo(() => {
    const { error, errorMessage } = state
    const errList = values(error)
    if (errList.length > 0) {
      return errList[0]
    }
    return errorMessage
  }, [state])

  useEffect(() => {
    if (state.ok) {
      toast.success('Your message has been sent successfully.', {
        position: 'top-center',
        autoClose: 2000,
      })
    } else if (errorMessage) {
      toast.error(errorMessage, {
        position: 'top-center',
        autoClose: 2000,
      })
    }
  }, [state, errorMessage])

  return (
    <form
      action={formAction}
      className='flex-1 flex flex-col gap-y-5 lg:gap-y-8'
    >
      <Input
        placeholder='Your name'
        name='name'
        required
        icon={<IconUser className='fill-current' />}
      />
      <Input
        placeholder='Your phone'
        name='phone'
        type='tel'
        icon={<IconPhone className='fill-current' />}
      />
      <Input
        placeholder='Your email'
        name='email'
        type='email'
        required
        icon={<IconEmail className='fill-current' />}
      />
      <Input
        placeholder='Your message'
        name='message'
        icon={<IconMessage className='fill-current' />}
      />
      <div className='mt-10 lg:mt-12.5'>
        <Button
          type='submit'
          arrow
          theme='black'
          outline
          bgTransparent
          loading={pending}
          className='w-full lg:w-45'
        >
          Submit
        </Button>
      </div>
    </form>
  )
}
